<template>
    <div :class="containerDesign">
        <ui-select-v2
            v-model="form.funnel_stage_id"
            :data="options.stage"
            :disabled="disabled.stage"
            :required="isRequired.stage"
            :loading="loader.stage"
            label="Etapa:"
            item-label="name"
            return-value="id"
            @input="statusHandler"
        />

        <ui-select-v2
            v-model="form.funnel_stage_status_id"
            :data="options.status"
            :disabled="disableStatus"
            :required="isRequired.status"
            :loading="loader.status"
            label="Status:"
            item-label="name"
            return-value="id"
        />
    </div>
</template>

<script>
	import { uiSelectV2 } from '@/components/ui/form'
	import { funnel } from '@/services/axios'

	import { utilMixin, formMixin, alertMixin, loaderMixin } from '@/mixins'

	const defaultForm = () => ({
		funnel_stage_id: null,
		funnel_stage_status_id: null,
	})

	const defaultLoader = () => ({
		stage: false,
		status: false,
	})

	const defaultRequired = () => ({
		stage: false,
		status: false,
	})

	const defaultDisabled = () => ({
		stage: false,
	})

	const defaultOptions = () => ({
		stage: [],
		status: [],
	})

	export default {
		name: 'ui-nugget-stage-status-form',

		components: {
			uiSelectV2,
		},

		mixins: [utilMixin, formMixin, alertMixin, loaderMixin],

		props: {
			value: {
				type: Object,
				required: true,
			},

			fetchList: {
				type: Object,
				default: () => ({}),
			},

			requiredFileds: {
				type: Object,
				default: () => ({}),
			},

			nuggetId: {
				type: [String, Number],
				default: ''
			},

			inlineDesign: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				options: { ...defaultOptions() },
				loader: { ...defaultLoader() },
				nuggetName: 'nugget-stage-status-form',
			}
		},

		computed: {
			isRequired() {
				return {
					...defaultRequired(),
					...this.requiredFileds,
				}
			},

			disableStatus() {
				return (
					!this.$mx_hasValue(this.form.funnel_stage_id) || this.options.status.length == 0
				)
			},

			nuggetTotalName() {
				return this.nuggetName + (this.nuggetId ? '-' + this.nuggetId : '')
			},

			containerDesign() {
				return {
					'gap-2': this.inlineDesign
				}
			}
		},

		watch: {
			options: {
				deep: true,
				handler(newValue) {
					this.$emit('update:fetchList', newValue)
				},
			},

			form: {
				deep: true,
				handler(newValue) {
					this.$emit('input', newValue)
				},
			},
		},

		mounted() {
			this.$root.$on(this.nuggetTotalName, async (payload) => {
				this.$mx_setLoader('stage', true)
				if (!this.options.stage.length) this.options.stage = await this.getStages()
				this.$mx_setLoader('stage', false)

				if (payload) {
					const { funnel_stage_id, funnel_stage_status_id } = payload
					if (funnel_stage_id) {
						this.form.funnel_stage_id = funnel_stage_id
						this.statusHandler(funnel_stage_id)
					}
					if (funnel_stage_status_id)
						this.form.funnel_stage_status_id = funnel_stage_status_id
				}
			})

			this.$root.$on('clean--' + this.nuggetTotalName, () => {
				this.form = { ...defaultForm() }
			})
		},

		beforeDestroy() {
			this.$root.$off(this.nuggetTotalName)
			this.$root.$off('clean--' + this.nuggetTotalName)
		},

		methods: {
			async getStages() {
				try {
					return (await funnel.getStages()).data
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			async statusHandler(id) {
				this.options.status = []
				this.form.funnel_stage_status_id = null
				if (!this.$mx_hasValue(id)) {
					this.form.funnel_stage_id = null
					return
				}

				this.options.status = this.getStatusByStageId(id)

				// Loader ilustrativo caso haja status.
				if (this.options.status.length !== 0) {
					this.$mx_setLoader('status', true)
					setTimeout(() => {
						this.$mx_setLoader('status', false)
					}, 500)
				}
			},

			getStatusByStageId(id) {
				if (!this.$mx_hasValue(id) && this.options.stage.length) return []
				const stage = this.options.stage.find((s) => s.id === parseInt(id))
				if (!stage) return []
				return [...stage.status]
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
